import { Component, NgZone, ViewChild, inject, signal, ChangeDetectionStrategy } from '@angular/core';
import { IEntityMetaData } from '@app/common-codes/_models/IEntityMetaData';
import { GenericComponent } from '@app/common-codes/components/_base/GenericComponent';
import { EntityConstructor } from '@app/common-codes/services/DependecyInjection.provider';
import { IStaticStylesConfig } from '@app/common-codes/skins/_primitives/IStaticStylesConfig';
import { MatwinsSkins } from '@app/common-codes/skins/global.skin';
import { TruckerActivity } from '@app/common-codes/models/matwins-tenant/TruckerActivity.model';
import { UploadDocumentComponent } from "../upload-document/upload-document.component";
import { ActivatedRoute, Router } from '@angular/router';
import { AlertModalService } from '@app/common-codes/services/AlertModalService';
import { GenericValidationService } from '@app/common-codes/services/GenericValidationService';
import { MatwinsVariablesService } from '@app/common-codes/services/matwinsVariables.service';
import { TranslationService } from '@app/common-codes/services/TranslationService';
import { QrCodeCheckModel } from '../../../models/qr-code/QrCodeCheck.model';
import { GenetricDetailComponent } from '@app/common-codes/components/edit-components/generic-detail.component';
import { TruckerActivityStackListComponent } from './trucker-activity-stack-list/trucker-activity-stack-list.component';
import { LookupItem, LookupService } from '@app/common-codes/services/LookupService';
import { FormsModule } from '@angular/forms';
import { TranslatePipe } from '@app/common-codes/components/directives/TranslatePipe';
import { Trucker } from '@app/common-codes/models/matwins-tenant/Trucker.model';
import { QrCodeActivityDetailComponent } from '../activity-detail/qr-code-activity-detail.component';
import { ValidationCodeComponent } from '../validation-code/validation-code.component';
import { ValidationCodeEntity } from '../../../models/qr-code/verificationCode.model';
import { MessageKeys } from '@app/common-codes/services/IMessageType';
import { Employee } from '@app/common-codes/models/matwins-tenant/Employee.model';
import { Tenant } from '@app/common-codes/models/matwins-tenant/Tenant.model';
import { DataService } from '@app/common-codes/services/DataService';
import { CurrentTenantService } from '@app/common-codes/services/CurrentTenantService';
import { DownloadDocumentComponent } from "@app/common-codes/components/nested-components/download-documents/download-document.component";

// ActivityStatus "In" (Admis) — cf. Matwins.Model ActivityStatus.GetAllStaticData()
const ACTIVITY_STATUS_IN = 1;

@Component({
  selector: 'app-trucker-checkin-checkout',
  imports: [UploadDocumentComponent, TruckerActivityStackListComponent, ValidationCodeComponent, FormsModule, QrCodeActivityDetailComponent, TranslatePipe, DownloadDocumentComponent],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './trucker-checkin-checkout.component.html'
})
export class TruckerCheckinCheckoutComponent extends GenetricDetailComponent<QrCodeCheckModel> {

  private readonly AUTH_STORAGE_KEY = 'trucker_auth_session';
  private readonly SESSION_MAX_AGE_HOURS = 24;

  override Skin = MatwinsSkins.QrCode1 as IStaticStylesConfig;
  override ComponentEntityClass = QrCodeCheckModel;
  override entityMetaData: IEntityMetaData = new QrCodeCheckModel().GetType();
  override Editable: boolean = false;
  files: File[] = [];
  public override get RequiredPermissions(): string[] {
    return [];
  }
  public override get HasRequiredPermissions(): boolean {
    return true;
  }


  languageLookup: LookupItem[] = [];
  truckerLookupData: LookupItem[] = [];
  selectedTruckerId: string | null = null;
  displayComponent: 'none' | 'truckerDetail' = 'none';
  selectedTrucker: Trucker | null = null;
  protected override lookupService: LookupService = inject(LookupService);
  public activities = signal<TruckerActivity[]>([]);
  public profiles = signal<Trucker[]>([]);
  public isActivitySelected = signal<boolean>(false);
  public selectedActivity = signal<TruckerActivity | null>(null)
  public fkPointOfServiceId: number | null = 0;
  public createNewProfile = signal<boolean>(false);
  public isNewActivity = signal<boolean>(false);
  public noActivityFound = signal<boolean>(false);
  public entrySiteSuccess = signal<boolean>(false);
  public exitSiteSuccess = signal<boolean>(false);
  public editSiteSuccess = signal<boolean>(false);

  public componentMode = signal<'checkin' | 'checkout' | 'edit' | undefined>(undefined);
  @ViewChild('truckerActivityDetail') detail!: QrCodeActivityDetailComponent;
  constructor(
    route: ActivatedRoute,
    router: Router,
    translationService: TranslationService,
    validationService: GenericValidationService,
    alertModalService: AlertModalService,
    matwinsVariables: MatwinsVariablesService,
    ngZone: NgZone,
    private currentTenantService: CurrentTenantService
  ) {
    super(route, router, translationService, validationService, ngZone);

    this.alertModalService = alertModalService;
    this.editingEntity.update(entity => {
      if (entity) {
        entity.isAuthenticated = false;
      }
      return entity;
    });

  }

  override ngOnInit() {
    super.ngOnInit();
  }

  filesChanged(files: File[]) {
    // console.log(files);
    this.files = files;

  }



  onActivitySelected(activity: TruckerActivity) {
    if (activity && activity.id !== this.selectedActivity()?.id) {
      this.selectedActivity.set(activity);
      this.isActivitySelected.set(true);
      this.isNewActivity.set(false);
    }
    else {
      this.selectedActivity.set(null);
      this.isActivitySelected.set(false);
    }
    console.log('Activity selected from stack list:', activity);
  }

  onActivityDetailSaved(savedActivity: TruckerActivity) {
    console.log('Activity saved from detail in stack list:', savedActivity);
  }


  onTruckerSelected(event: Event) {
    const target = event.target as HTMLSelectElement;
    this.selectedTruckerId = target.value;
    console.log('Selected Trucker ID:', this.selectedTruckerId);
    if (this.selectedTruckerId === 'new-profile') {
      this.selectedTrucker = new Trucker();
      this.selectedTrucker.email = this.editingEntity()?.email ?? '';
      this.selectedTrucker.phoneNumber = this.editingEntity()?.phoneNumber ?? '';
      this.displayComponent = 'truckerDetail';

      this.createNewProfile.set(true);
      if (this.selectedActivity()) {
        const newActivity = Object.assign(new TruckerActivity(), this.selectedActivity());

        let selectedLanguage = this.lookupService.getLookupData('i18nLanguage').filter((lang) => { return lang.value == this.currentLanguage }).at(0);
        newActivity.trucker = this.selectedTrucker;
        //  newActivity.fk_Trucker = 0;
        newActivity.trucker.fK_Language = Number.parseInt(selectedLanguage?.id || '1');
        newActivity.trucker.fullName = '';
        newActivity.trucker.companyName = '';
        newActivity.trucker.phoneNumber = this.editingEntity()?.phoneNumber ?? '';
        newActivity.trucker.email = this.editingEntity()?.email ?? '';
        this.selectedActivity.set(newActivity);
      }
    } else if (this.selectedTruckerId) {
      this.displayComponent = 'none';
      this.selectedTrucker = null;
      this.createNewProfile.set(false);
      const selectedProfile = this.profiles().find(p => p.id?.toString() === this.selectedTruckerId);
      if (selectedProfile && this.selectedActivity()) {
        const newActivity = Object.assign(new TruckerActivity(), this.selectedActivity());
        newActivity.trucker = selectedProfile;
        // newActivity.fk_Trucker = selectedProfile.id ?? 0;
        this.selectedActivity.set(newActivity);
      }
    } else {
      this.displayComponent = 'none';
      this.selectedTrucker = null;
      this.createNewProfile.set(false);
      if (this.selectedActivity()) {
        const newActivity = Object.assign(new TruckerActivity(), this.selectedActivity());
        newActivity.trucker = null;
        // newActivity.fk_Trucker = 0;
        this.selectedActivity.set(newActivity);
      }
    }
  }
  onTruckerSaved(savedTrucker: Trucker) {
    console.log('Trucker saved:', savedTrucker);
    this.displayComponent = 'none';
    this.selectedTrucker = null;
    if (this.selectedActivity()) {
      const updatedActivity = Object.assign(new TruckerActivity(), this.selectedActivity());
      updatedActivity.trucker = savedTrucker;
      //  updatedActivity.fk_Trucker = savedTrucker.id ?? 0;
      this.selectedActivity.set(updatedActivity);
    }
    this.profiles.update(profs => [...profs, savedTrucker]);
    this.selectedTruckerId = savedTrucker.id?.toString() ?? null;
  }
  onCreateNewActivity() {
    this.isNewActivity.set(true);
    this.selectedTruckerId = null;
    this.selectedTrucker = null;
    const newActivity = new TruckerActivity();
    newActivity.status = ACTIVITY_STATUS_IN;
    // deliveryType on va chercher la valeur par defaut depuis le lookup
    const activityDeliveryTypeLookup = this.lookupService.getLookupData('ActivityDeliveryType');
    if (activityDeliveryTypeLookup && activityDeliveryTypeLookup.length > 0) {
      newActivity.deliveryType = Number(activityDeliveryTypeLookup[0].id);
    }
    this.selectedActivity.set(newActivity);
    this.isActivitySelected.set(true);
  }


  codeGenerated(event: any) {
    console.log(event);
  }



  dataChanged(event: any) {
    console.log(event);
    this.editingEntity.update(entity => {
      if (entity) {
        entity.validationCode = event;
      }
      return entity;
    });
  }
  //async validationSuccess(authenticatedUser: QrCodeCheckModel):Promise<any> {
  //  this.editingEntity.set(authenticatedUser);
  //  this.noActivityFound.set(false); // efface message

  //  await this.loadDataWithAuthentication();
  //}


  //override async ngAfterViewInit() {
  //  super.ngAfterViewInit();
  //  this.componentMode.set(this.matwinsVariables.ckeckOperation);
  //  // Appel anticipe (force) des lookup
  //  //(async () => {

  //    await this.dataService.getLookupsByNames(['ActivityStatus', 'ActivityDeliveryType', 'PointOfService', 'i18nLanguage']);
  //  //})();
  //  this.fkPointOfServiceId = this.matwinsVariables.posId as number;
  //  if (this.editingEntity()?.isAuthenticated) {
  //    await this.loadDataWithAuthentication();
  //  }
  //}

  async validationSuccess(authenticatedUser: QrCodeCheckModel): Promise<void> {
    if (this.componentMode() === 'edit') {
      var payload = authenticatedUser as any;

      if (payload) {
        //ajoute les propriétés de authenticatedUser dans payload
        Object.assign(payload, authenticatedUser);
        payload.posId = `${this.matwinsVariables.posId}`;
        payload.clientId = `${this.matwinsVariables.clientId}`;
        payload.tenantPrefix = `${this.matwinsVariables.tenantPrefix}`;
        payload.activityId = this.matwinsVariables.currentEntityId;
        payload.operation = this.componentMode();
        const result = await this.dataService.execute<any>('POST', 'checkResponsible', payload);
        console.log(result);
        if (result?.success && result?.responsible != null) {
          authenticatedUser.isUnAuthorized = false;

          this.editingEntity.set(authenticatedUser);
          this.saveAuthenticatedUserToStorage(authenticatedUser);

          this.noActivityFound.set(false);
          await this.loadDataWithAuthentication();
        }
        else {
          authenticatedUser.isUnAuthorized = true;
          this.editingEntity.set(authenticatedUser);
          this.noActivityFound.set(true);
        }

      }
    }
    else {
      authenticatedUser.isUnAuthorized = false;

      this.editingEntity.set(authenticatedUser);
      this.noActivityFound.set(false);
      if (this.componentMode() === 'checkin' || this.componentMode() === 'checkout') {
        this.saveAuthenticatedUserToStorage(authenticatedUser);

        await this.loadDataWithAuthentication();

      }

    }

  }

  override async ngAfterViewInit() {
    super.ngAfterViewInit();

    this.componentMode.set(this.matwinsVariables.ckeckOperation);

    // Forcer les lookups nécessaires
    await this.dataService.getLookupsByNames([
      'ActivityStatus',
      'ActivityDeliveryType',
      'PointOfService',
      'i18nLanguage',
      'Dock'
    ]);

    this.fkPointOfServiceId = this.matwinsVariables.posId as number;

    // authentication AUTO en mode "CHECKOUT""
    //

    if (this.componentMode() === 'checkout') {
      const storedUser = this.getAuthenticatedUserFromStorage();
      if (storedUser) {
        // Session valide :  on bypass l'authentification
        this.editingEntity.set(storedUser);
        await this.loadDataWithAuthentication();
        return; // on sort, pas besoin d'afficher le composant validation-code
      }

    }
    else if (this.componentMode() === 'edit') {
      const storedUser = this.getAuthenticatedUserFromStorage();
      if (storedUser) {
        // Session valide :  on bypass l'authentification
        this.editingEntity.set(storedUser);
        await this.loadDataWithAuthentication();
        return; // on sort, pas besoin d'afficher le composant validation-code
      }
    }

    // En mode checkin : on force toujours le nettoyage (comportement naturel)
    else if (this.componentMode() === 'checkin') {
      this.clearAuthenticatedUserFromStorage();
    }

    // Cas normal : pas de session valide ou mode checkin : l'auth manuelle est imperative
    if (this.editingEntity()?.isAuthenticated) {
      await this.loadDataWithAuthentication();
    }
  }


  async loadDataWithAuthentication(): Promise<any> {
    const result = await this.loadData();

    if (result) {

      if (!result.activities)
        result.activities = [];

      if (!result.profiles)
        result.profiles = [];


      this.activities.set(result.activities);
      this.profiles.set(result.profiles);

      if (this.componentMode() === 'edit') {
        this.selectedActivity.set(result.activities[0]);
      }

      if (result.activities.length > 0) {
        this.noActivityFound.set(false);
      }
      else {
        this.noActivityFound.set(true);
        // ATTENTION : ?? result.viewState = this.disconnectUser(result.viewState);
      }
    }
    // Retablir le view-state retourne du backend
    if (result.viewState) {
      let updatedViewState: QrCodeCheckModel = {
        ...result.viewState,

        responsibles: result.responsibles,
        authenticationDateTime: result.authenticationDateTime
      }

      this.editingEntity.set(updatedViewState);
    }
  }
  private disconnectUser(viewState: any): any {
    viewState.userAuthenticated = false;
    viewState.email = undefined;
    viewState.phoneNumber = undefined;
    return viewState;
  }
  override async loadData(): Promise<any> {
    try {
      // editingEntity() model comme payload
      let payload = this.editingEntity() as any;
      if (payload) {

        payload.posId = `${this.matwinsVariables.posId}`;
        payload.clientId = `${this.matwinsVariables.clientId}`;
        payload.tenantPrefix = `${this.matwinsVariables.tenantPrefix}`;
        payload.activityId = this.matwinsVariables.currentEntityId;
        payload.operation = this.componentMode();
        const result = await this.dataService.execute<any>(
          'POST',
          'checkin-initialize',
          payload
        );
        if (result.success)
          return result;
        else
          throw new Error('LoadData failed');
      }
    } catch (err) {
      console.error("Erreur lors de l'appel custom :", err);
    }
  }
  override parseToEntityInstance(): void {
    throw new Error('Method not implemented.');
  }
  override getEmptyEntity(): QrCodeCheckModel {
    let newEntity = new QrCodeCheckModel();
    newEntity.isAuthenticated = false;
    return newEntity;
  }
  async onEnterSite(): Promise<void> {
    await this.submitActivity();
  }
  async onExitSite(): Promise<void> {
    await this.submitActivity();
  }

  async onEditSubmit(): Promise<void> {
    await this.submitActivity();
  }

  private async submitActivity(): Promise<void> {
    if (!this.detail) {
      console.error("qr-code-activity-detail component not found.");
      return;
    }
    this.loaderService.show();
    try {
      let slectedLanguage = this.lookupService.getLookupData('i18nLanguage').filter((lang) => { return lang.value == this.currentLanguage }).at(0);

      const validatedActivity = this.detail.validateFormAndGetData(this.componentMode() === 'checkin');
      if (validatedActivity) {
        console.log("Form is valid. Data to send:", validatedActivity);

        try {
          let payload = this.editingEntity() as any;
          payload.posId = `${this.matwinsVariables.posId}`;
          payload.clientId = `${this.matwinsVariables.clientId}`;
          payload.tenantPrefix = `${this.matwinsVariables.tenantPrefix}`;
          payload.truckerActivity = validatedActivity;
          payload.truckerActivity.trucker.fK_Language = slectedLanguage?.id || '1';
          payload.truckerActivity.trucker.pointOfService = null;
          payload.operation = this.componentMode();
          if (payload.operation === 'checkin')
            payload.truckerActivity.status = ACTIVITY_STATUS_IN;

          this.addTranslatedMessages(payload);

          const tenant = this.currentTenantService.currentTenant();
          //mettre l'url courante + /qrcode/:tenant/:pos/uploads — l'id de l'activité est ajouté côté serveur
          payload.qrCodeUploadUrl = `${window.location.origin}/qrcode/${tenant?.managerClient}/${payload.posId}/uploads`;
          //SignOutUrl
          payload.signoutUrl = `${window.location.origin}/qrcode/${tenant?.managerClient}/${payload.posId}/trucker-checkout`;


          const result = await this.dataService.execute<any>(
            'POST',
            'checkin-data',
            payload
          );
          if (result.success) {
            console.log("Data successfully sent to backend:", result);

            try {
              if (this.files && this.files.length > 0) {
                const formData = new FormData();
                this.files.forEach(file => {
                  formData.append('files', file);
                });
                formData.append('entityId', result.truckerActivity.id);
                formData.append('relationName', 'FK_Attachments');
                const uploadResult = await this.dataService.execute<any>('Post', 'upload-multiple', formData);
                console.log("Files uploaded successfully:", uploadResult);
              }
            }
            catch (error) {
              console.error('Error uploading files:', error);
              // return false;
            }


            if (result.viewState) {
              this.editingEntity.set(result.viewState);
            }
            if (this.componentMode() === 'checkin') {
              this.entrySiteSuccess.set(true);
            } else if (this.componentMode() === 'checkout') {
              this.exitSiteSuccess.set(true);

              this.clearAuthenticatedUserFromStorage(); // on efface la session
              console.log("Session invalidated after successful checkout");
            } else if (this.componentMode() === 'edit') {
              this.editSiteSuccess.set(true);
            }
          } else {
            console.error("Backend returned an error:", result);

          }
        } catch (err) {
          console.error("Error sending data to backend:", err);

        }
      } else {
        console.log("Form is invalid. Please correct the errors.");
      }
    }
    finally {
      this.loaderService.hide();
    }
  }


  private generateEmployeeMessages = (currentEmployee: Employee, operationName: 'checkin' | 'checkout' | 'edit', languageSuffix: string): void => {
    MessageKeys.forEach(key => {
      const translationKey = `messages.multi-langual-messages.trucker-responsibles-${operationName}.${key}${languageSuffix}`;
      const recordKey = `${operationName}-${key}` as const;
      let tranlatedMessage = this.translationService.instant(translationKey)
      currentEmployee.messages[recordKey] = tranlatedMessage;
    });
  };


  // ajout des messages a l'usage des responsables 
  addTranslatedMessages(payload: any) {
    let responsibles = this.editingEntity()?.responsibles;

    if (responsibles && responsibles.length > 0) {

      responsibles?.map(currentEmployee => {
        const languageSuffix = `_${currentEmployee.language?.key || '_en'}`;
        currentEmployee.messages = {} as Record<string, string>;       // Initialiser le Record des messages pour cet employé

        this.generateEmployeeMessages(currentEmployee, this.componentMode() || 'checkin', languageSuffix);
      });

      payload.responsibles = responsibles;
    }

    //ajouter les messages au modèles à transmettre
    payload.messages = {};
    payload.messages['truckerDockEmailBody'] = this.translationService.instant(`messages.multi-langual-messages.trucker-dock.email-body`);
    payload.messages['truckerDockEmailSubject'] = this.translationService.instant(`messages.multi-langual-messages.trucker-dock.email-subject`);
    payload.messages['truckerDockSmsBody'] = this.translationService.instant(`messages.multi-langual-messages.trucker-dock.sms-body`);
    payload.messages['truckerInsideEmailBody'] = this.translationService.instant(`messages.multi-langual-messages.trucker-inside.email-body`);
    payload.messages['truckerInsideEmailSubject'] = this.translationService.instant(`messages.multi-langual-messages.trucker-inside.email-subject`);
    payload.messages['truckerInsideSmsBody'] = this.translationService.instant(`messages.multi-langual-messages.trucker-inside.sms-body`);
  }


  //
  isUserAuthenticated(): boolean {
    let isAuth = this.editingEntity()?.isAuthenticated ? true : false;
    return isAuth;
  }
  isUserAuthorized(): boolean {
    let isAuth = this.editingEntity()?.isUnAuthorized ? false : true;
    return isAuth;
  }

  // authentification 
  reAuthenticate() {
    this.editingEntity.update(entity => {
      if (entity) {
        entity.isAuthenticated = false;
        entity.email = undefined;
        entity.phoneNumber = undefined;
        entity.validationCode = new ValidationCodeEntity();
      }
      return entity;
    });
    this.activities.set([]);
    this.profiles.set([]);
    this.selectedActivity.set(null);
    this.isActivitySelected.set(false);
    this.isNewActivity.set(false);
    this.noActivityFound.set(false);
  }

  private saveAuthenticatedUserToStorage(user: QrCodeCheckModel): void {
    if (!user || !user.authenticationDateTime) return;

    const data = {
      ...user,
      // On s'assure que la date est bien une string ISO
      authenticationDateTime: user.authenticationDateTime instanceof Date
        ? user.authenticationDateTime.toISOString()
        : user.authenticationDateTime
    };

    localStorage.setItem(this.AUTH_STORAGE_KEY, JSON.stringify(data));
  }

  private getAuthenticatedUserFromStorage(): QrCodeCheckModel | null {
    const raw = localStorage.getItem(this.AUTH_STORAGE_KEY);
    if (!raw) return null;

    try {
      const data = JSON.parse(raw);
      const authDate = new Date(data.authenticationDateTime);
      if (isNaN(authDate.getTime())) return null;

      const hoursDiff = (Date.now() - authDate.getTime()) / (1000 * 60 * 60);
      if (hoursDiff > this.SESSION_MAX_AGE_HOURS) {
        this.clearAuthenticatedUserFromStorage();
        return null;
      }

      // Reconstruire l'objet avec la bonne classe si necessaire
      const user = new QrCodeCheckModel();
      Object.assign(user, data);
      return user;
    } catch (err) {
      console.warn('Invalid auth data in localStorage', err);
      this.clearAuthenticatedUserFromStorage();
      return null;
    }
  }

  private clearAuthenticatedUserFromStorage(): void {
    localStorage.removeItem(this.AUTH_STORAGE_KEY);
  }

  private isValidStoredSession(): boolean {
    return !!this.getAuthenticatedUserFromStorage();
  }

  goToCheckout(): void {
    if (!this.matwinsVariables.clientId || !this.matwinsVariables.posId) {
      console.warn('Cannot redirect to checkout: missing clientId or posId');
      return;
    }

    this.router.navigateByUrl(`/qrcode/${this.matwinsVariables.clientId}/${this.matwinsVariables.posId}/trucker-checkout`);
  }

}
